import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';

export class Media {
    file_path: string;
    file_type: number;
};


@Injectable()
export class PlayerService {
    private mediaContent:any = new Subject<Media>();

    constructor() {

    }

    getMediaContent(): Observable<any> {
        return this.mediaContent.asObservable();
    }

    emitMediaContent(mediaFields: any) {
        setTimeout(() => {
            this.mediaContent.next(<Media>mediaFields);
        }, 300);
    };

    clear() {
        this.mediaContent.next();
    }
}
